import { useCallback, useMemo } from 'react';

import { UserType } from '@enums/index';

import {
    useLazyGetMenteeAdditionalExpQuery,
    useLazyGetMentorAdditionalExpQuery,
} from '../api/additionalExperience';
import { AdditionalExpResponse } from '../types';

interface GetAdditionalExpProps {
    userType: UserType;
}

export default function useGetAdditionalExp({ userType }: GetAdditionalExpProps) {
    const [
        getMentorAdditionalExp,
        { data: mentorAdditionalExperience, isLoading: isMentorLoading },
    ] = useLazyGetMentorAdditionalExpQuery();

    const [
        getMenteeAdditionalExp,
        { data: menteeAdditionalExperience, isLoading: isMenteeLoading },
    ] = useLazyGetMenteeAdditionalExpQuery();

    const isLoading = useMemo(
        () => isMentorLoading || isMenteeLoading,
        [isMentorLoading, isMenteeLoading]
    );

    const additionalExperience = useMemo(
        () => mentorAdditionalExperience || menteeAdditionalExperience,
        [mentorAdditionalExperience, menteeAdditionalExperience]
    );

    const getAdditionalExp = useCallback(
        (username: string) => {
            let experiencesData: AdditionalExpResponse;
            switch (userType) {
                case UserType.Mentor:
                    getMentorAdditionalExp({ username });
                    break;
                case UserType.Mentee:
                    getMenteeAdditionalExp({ username });
                    break;
                default:
                    break;
            }
            return experiencesData!;
        },
        [userType, getMentorAdditionalExp, getMenteeAdditionalExp]
    );
    return {
        getAdditionalExp,
        isLoading,
        additionalExperience,
    };
}
